import {
  camelCase,
  kebabCase,
  snakeCase,
  startCase,
  upperFirst,
} from "lodash-es";

export const textFormatTypes = [
  "none",
  "sentence_case",
  "start_case",
  "lower_case",
  "upper_case",
  "kebab_case",
  "snake_case",
  "camel_case",
  "pascal_case",
] as const;
export type TextFormatType = (typeof textFormatTypes)[number];

export function isTextFormatType(value: string): value is TextFormatType {
  return textFormatTypes.includes(value as TextFormatType);
}

export function toSentenceCase(text: string): string {
  return upperFirst(text);
}

export function toStartCase(text: string): string {
  return startCase(text);
}

export function toLowerCase(text: string): string {
  return text.toLowerCase();
}

export function toUpperCase(text: string): string {
  return text.toUpperCase();
}

export function toKebabCase(text: string): string {
  return kebabCase(text);
}

export function toSnakeCase(text: string): string {
  return snakeCase(text);
}

export function toCamelCase(text: string): string {
  return camelCase(text);
}

export function toPascalCase(text: string): string {
  return upperFirst(camelCase(text));
}

export function formatText(text: string, formatType: TextFormatType): string {
  switch (formatType) {
    case "none":
      return text;

    case "sentence_case":
      return toSentenceCase(text);

    case "start_case":
      return toStartCase(text);

    case "lower_case":
      return text.toLowerCase();

    case "upper_case":
      return text.toUpperCase();

    case "kebab_case":
      return text.toLowerCase().replace(/ /g, "-");

    case "snake_case":
      return text.toLowerCase().replace(/ /g, "_");

    case "camel_case":
      return camelCase(text);

    case "pascal_case":
      return upperFirst(camelCase(text));
  }
}
